// extracted by mini-css-extract-plugin
export default {"background":"Users_background__DsB4d"};